export const generatedCapabilityMaturityLedger = {
  "schemaVersion": 1,
  "generatedAt": "2026-06-19T00:00:00.000Z",
  "mode": "deterministic-capability-maturity-ledger",
  "operatingRule": "Business capabilities can be shown as roadmap or beta intelligence only; commercial proof requires source-backed artifacts, promotable claims, and passing runtime validation gates.",
  "capabilityCount": 9,
  "blockedCapabilityCount": 9,
  "commercializationAllowed": false,
  "topCapabilities": [
    {
      "id": "business-research-workflow",
      "maturityScore": 78.95,
      "maturityBand": "beta-reviewable",
      "commercializationAllowed": false
    },
    {
      "id": "evidence-provenance",
      "maturityScore": 78.94,
      "maturityBand": "beta-reviewable",
      "commercializationAllowed": false
    },
    {
      "id": "ephemeris-event-windows",
      "maturityScore": 65.49,
      "maturityBand": "research-backed",
      "commercializationAllowed": false
    }
  ],
  "evidenceHashes": {
    "sourceRegistry": "sha256-f71caf92b2e76cd344ad65330ce3533cc1f5657002f82b6ff69fa39acdb89780",
    "modelArtifactBundle": "sha256-f3b0e534f4e7fb6c252f258ea4c741d6ee42b9bafb479bfb6e680c3c2d48a030",
    "sourceRefreshReport": "sha256-40225cf6dbb39b9d856a97ea259a1b460f2a4d090182bcfdab17eac69941ad02",
    "claimEvidenceLedger": "sha256-955a2d2ec1bb591b69b89b51865539cae43207d81051e6ba2e9bbfc696c37770",
    "sidecarValidationReport": "sha256-aa8df127fd6f74cef0ba42b0ee62827380c4fb8d328808fd77d0793755c90b1f",
    "scenarioDecisionLedger": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
    "economicsFrontier": "sha256-e2d5dbb01f50cfbb0ccf93703eafd923ae088b68f6f757b3b1e20497ffac4adf",
    "materialsProcessEvidenceLedger": "sha256-860c27709b9c2e64ffb883271d74cf5b6e44d14c8c8d2c22404f2adda2914f80"
  },
  "globalBlockers": [
    "Runtime SPICE/Orekit/GMAT/Tudat artifacts are still required for mission-design promotion.",
    "Candidate-specific asteroid taxonomy/spectra/mission data is still required for resource promotion.",
    "Dated launch-cost, capex, opex, and market-source records are still required for economics promotion.",
    "Cantera/MOOSE/OpenFOAM process artifacts are still required before material/process scores become engineering evidence.",
    "SPDF/CCMC/SWPC environment artifacts are still required before radiation/space-weather assumptions promote."
  ],
  "capabilities": [
    {
      "id": "business-research-workflow",
      "label": "Business research workflow",
      "businessUse": "Turn model runs into reviewer-ready research packages without overstating validation.",
      "maturityScore": 78.95,
      "maturityBand": "beta-reviewable",
      "commercializationAllowed": false,
      "scores": {
        "sourceCoverage": 100,
        "artifactCoverage": 67.07,
        "claimCoverage": 92.47,
        "sidecarCoverage": 60,
        "processEvidence": null
      },
      "sourceRefs": [
        {
          "sourceId": "pds",
          "title": "Planetary Data System",
          "trust": "primary",
          "sourceType": "mission-data-archive",
          "recordHash": "fnv1a32-7c477cc2",
          "url": "https://pds.nasa.gov/datasearch/data-search/"
        },
        {
          "sourceId": "horizons-api",
          "title": "JPL Horizons API",
          "trust": "primary",
          "sourceType": "ephemeris-api",
          "recordHash": "fnv1a32-9335c241",
          "url": "https://ssd-api.jpl.nasa.gov/doc/horizons.html"
        },
        {
          "sourceId": "sbdb-api",
          "title": "JPL Small-Body Database API",
          "trust": "primary",
          "sourceType": "small-body-orbit-api",
          "recordHash": "fnv1a32-93c0fe91",
          "url": "https://ssd-api.jpl.nasa.gov/doc/sbdb.html"
        },
        {
          "sourceId": "cad-api",
          "title": "SBDB Close Approach Data API",
          "trust": "primary",
          "sourceType": "close-approach-api",
          "recordHash": "fnv1a32-ba0c45bb",
          "url": "https://ssd-api.jpl.nasa.gov/doc/cad.html"
        }
      ],
      "artifactRefs": [
        {
          "artifactId": "artifact-horizons-geometry-v1",
          "name": "Horizons Earth/Mercury geometry snapshot",
          "claimState": "source-backed",
          "runtimeStatus": "deterministic-snapshot",
          "artifactHash": "fnv1a32-84000384"
        },
        {
          "artifactId": "artifact-sbdb-cad-screen-v1",
          "name": "SBDB/CAD small-body candidate screen",
          "claimState": "source-backed-blocked",
          "runtimeStatus": "deterministic-snapshot",
          "artifactHash": "fnv1a32-38332261"
        },
        {
          "artifactId": "artifact-economics-uncertainty-v1",
          "name": "Economics and Monte Carlo frontier artifact",
          "claimState": "model-derived-unvalidated",
          "runtimeStatus": "deterministic-generated-monte-carlo",
          "artifactHash": "fnv1a32-83d7b008"
        }
      ],
      "contractRefs": [],
      "claimRefs": [
        {
          "claimId": "claim-mercury-flux",
          "status": "Verified",
          "evidenceGrade": "A-reviewable",
          "promotionAllowed": true
        },
        {
          "claimId": "claim-dtn",
          "status": "Verified",
          "evidenceGrade": "A-reviewable",
          "promotionAllowed": true
        },
        {
          "claimId": "claim-de440-boundary",
          "status": "Verified",
          "evidenceGrade": "A-reviewable",
          "promotionAllowed": true
        }
      ],
      "proofGates": [
        "Packages carry report, claim, source, assumption, and decision ledger hashes.",
        "Approvals are recorded separately from scientific validation.",
        "No paid research output removes blockers from unvalidated claims."
      ],
      "processEvidence": null,
      "blockers": [],
      "nextActions": [
        "Record reviewer approval evidence."
      ],
      "capabilityHash": "sha256-7e183b1d62f96927df37a94e88858e7538c5b937b073e7d6820e9536029e39a0"
    },
    {
      "id": "evidence-provenance",
      "label": "Evidence and provenance layer",
      "businessUse": "Make customer-facing research claims traceable, hash-backed, and defensible.",
      "maturityScore": 78.94,
      "maturityBand": "beta-reviewable",
      "commercializationAllowed": false,
      "scores": {
        "sourceCoverage": 100,
        "artifactCoverage": 66.15,
        "claimCoverage": 93.8,
        "sidecarCoverage": 60,
        "processEvidence": null
      },
      "sourceRefs": [
        {
          "sourceId": "horizons-api",
          "title": "JPL Horizons API",
          "trust": "primary",
          "sourceType": "ephemeris-api",
          "recordHash": "fnv1a32-9335c241",
          "url": "https://ssd-api.jpl.nasa.gov/doc/horizons.html"
        },
        {
          "sourceId": "sbdb-api",
          "title": "JPL Small-Body Database API",
          "trust": "primary",
          "sourceType": "small-body-orbit-api",
          "recordHash": "fnv1a32-93c0fe91",
          "url": "https://ssd-api.jpl.nasa.gov/doc/sbdb.html"
        },
        {
          "sourceId": "cad-api",
          "title": "SBDB Close Approach Data API",
          "trust": "primary",
          "sourceType": "close-approach-api",
          "recordHash": "fnv1a32-ba0c45bb",
          "url": "https://ssd-api.jpl.nasa.gov/doc/cad.html"
        },
        {
          "sourceId": "pds",
          "title": "Planetary Data System",
          "trust": "primary",
          "sourceType": "mission-data-archive",
          "recordHash": "fnv1a32-7c477cc2",
          "url": "https://pds.nasa.gov/datasearch/data-search/"
        },
        {
          "sourceId": "nist-codata",
          "title": "2022 CODATA Fundamental Physical Constants",
          "trust": "primary",
          "sourceType": "physical-constants",
          "recordHash": "fnv1a32-333cff52",
          "url": "https://physics.nist.gov/cuu/Constants/Table/allascii.txt"
        }
      ],
      "artifactRefs": [
        {
          "artifactId": "artifact-horizons-geometry-v1",
          "name": "Horizons Earth/Mercury geometry snapshot",
          "claimState": "source-backed",
          "runtimeStatus": "deterministic-snapshot",
          "artifactHash": "fnv1a32-84000384"
        },
        {
          "artifactId": "artifact-economics-uncertainty-v1",
          "name": "Economics and Monte Carlo frontier artifact",
          "claimState": "model-derived-unvalidated",
          "runtimeStatus": "deterministic-generated-monte-carlo",
          "artifactHash": "fnv1a32-83d7b008"
        }
      ],
      "contractRefs": [],
      "claimRefs": [
        {
          "claimId": "claim-de440-boundary",
          "status": "Verified",
          "evidenceGrade": "A-reviewable",
          "promotionAllowed": true
        }
      ],
      "proofGates": [
        "Every displayed claim has source records and promotion blockers.",
        "Every generated artifact has a reproducible hash.",
        "Commercial proof remains blocked when evidence is partial."
      ],
      "processEvidence": null,
      "blockers": [],
      "nextActions": [
        "Record reviewer approval evidence."
      ],
      "capabilityHash": "sha256-7e744aa89d353106b30afd2a0ae930990b7678a675a3e8e3279612300eaf1706"
    },
    {
      "id": "ephemeris-event-windows",
      "label": "Ephemeris and event-window intelligence",
      "businessUse": "Compare contact, solar-interference, conjunction, and light-time windows across destinations.",
      "maturityScore": 65.49,
      "maturityBand": "research-backed",
      "commercializationAllowed": false,
      "scores": {
        "sourceCoverage": 100,
        "artifactCoverage": 66.3,
        "claimCoverage": 93.8,
        "sidecarCoverage": 10,
        "processEvidence": null
      },
      "sourceRefs": [
        {
          "sourceId": "horizons-api",
          "title": "JPL Horizons API",
          "trust": "primary",
          "sourceType": "ephemeris-api",
          "recordHash": "fnv1a32-9335c241",
          "url": "https://ssd-api.jpl.nasa.gov/doc/horizons.html"
        },
        {
          "sourceId": "spice-gf",
          "title": "SPICE Geometry Finder",
          "trust": "primary",
          "sourceType": "ephemeris-event-software",
          "recordHash": "fnv1a32-97d74c96",
          "url": "https://naif.jpl.nasa.gov/pub/naif/toolkit_docs/C/req/gf.html"
        },
        {
          "sourceId": "iau-sofa",
          "title": "Standards of Fundamental Astronomy",
          "trust": "primary",
          "sourceType": "astronomy-standards",
          "recordHash": "fnv1a32-2a854c84",
          "url": "https://www.iausofa.org/"
        }
      ],
      "artifactRefs": [
        {
          "artifactId": "artifact-horizons-geometry-v1",
          "name": "Horizons Earth/Mercury geometry snapshot",
          "claimState": "source-backed",
          "runtimeStatus": "deterministic-snapshot",
          "artifactHash": "fnv1a32-84000384"
        },
        {
          "artifactId": "artifact-spice-gf-windows-v1",
          "name": "SPICE Geometry Finder event-window contract",
          "claimState": "adapter-contract",
          "runtimeStatus": "adapter-fixture",
          "artifactHash": "fnv1a32-6f7f670c"
        }
      ],
      "contractRefs": [
        {
          "contractId": "spice-gf-event-window-v1",
          "tool": "NASA NAIF SPICE Geometry Finder",
          "domain": "ephemeris-event-windows",
          "validationStatus": "blocked-no-runtime-artifact",
          "promotionAllowed": false
        }
      ],
      "claimRefs": [
        {
          "claimId": "claim-de440-boundary",
          "status": "Verified",
          "evidenceGrade": "A-reviewable",
          "promotionAllowed": true
        }
      ],
      "proofGates": [
        "Live Horizons refresh artifacts are preserved as deterministic snapshots.",
        "SPICE GF runtime artifact includes kernel hashes and generated event windows.",
        "Time scale is TDB/ET for physics outputs."
      ],
      "processEvidence": null,
      "blockers": [
        "Runtime sidecar validation blocked: spice-gf-event-window-v1"
      ],
      "nextActions": [
        "Runtime sidecar validation blocked: spice-gf-event-window-v1"
      ],
      "capabilityHash": "sha256-ec170468acb6a970fd48343370f7aa8e9b9132f2a2d4edba492d851b4a335e0a"
    },
    {
      "id": "space-environment",
      "label": "Space environment and radiation context",
      "businessUse": "Add radiation, solar-weather, and plasma-environment constraints to industrial scenario testing.",
      "maturityScore": 65.22,
      "maturityBand": "research-backed",
      "commercializationAllowed": false,
      "scores": {
        "sourceCoverage": 100,
        "artifactCoverage": 31.2,
        "claimCoverage": 70,
        "sidecarCoverage": 60,
        "processEvidence": null
      },
      "sourceRefs": [
        {
          "sourceId": "nasa-spdf",
          "title": "NASA Space Physics Data Facility",
          "trust": "primary",
          "sourceType": "heliophysics-data-archive",
          "recordHash": "fnv1a32-05f4400c",
          "url": "https://spdf.gsfc.nasa.gov/"
        },
        {
          "sourceId": "nasa-ccmc",
          "title": "Community Coordinated Modeling Center",
          "trust": "primary",
          "sourceType": "space-weather-modeling-center",
          "recordHash": "fnv1a32-1a450de5",
          "url": "https://ccmc.gsfc.nasa.gov/"
        },
        {
          "sourceId": "noaa-swpc",
          "title": "NOAA Space Weather Prediction Center Products and Data",
          "trust": "primary",
          "sourceType": "space-weather-products",
          "recordHash": "fnv1a32-dbbbdd09",
          "url": "https://www.spaceweather.gov/products-and-data"
        }
      ],
      "artifactRefs": [
        {
          "artifactId": "artifact-space-environment-v1",
          "name": "Space environment and radiation evidence contract",
          "claimState": "hypothesis",
          "runtimeStatus": "design-contract",
          "artifactHash": "fnv1a32-2d8fc05a"
        }
      ],
      "contractRefs": [],
      "claimRefs": [],
      "proofGates": [
        "SPDF/CDAWeb datasets are attached by variable, cadence, and time range.",
        "CCMC model runs preserve model name, version, inputs, and output hashes.",
        "NOAA/SWPC products are dated and not treated as long-range deterministic truth."
      ],
      "processEvidence": null,
      "blockers": [
        "No SPDF/CCMC/SWPC runtime environment artifact has been generated."
      ],
      "nextActions": [
        "No SPDF/CCMC/SWPC runtime environment artifact has been generated."
      ],
      "capabilityHash": "sha256-b7a78156a88135d6762ec1fda91b7e4f47db8642667cf278eb44686cb8d1eaa3"
    },
    {
      "id": "materials-process",
      "label": "Materials and industrial process modeling",
      "businessUse": "Evaluate whether a destination actually fits manufacturable processes and material constraints.",
      "maturityScore": 62.91,
      "maturityBand": "research-backed",
      "commercializationAllowed": false,
      "scores": {
        "sourceCoverage": 91.43,
        "artifactCoverage": 33.3,
        "claimCoverage": 65.8,
        "sidecarCoverage": 60,
        "processEvidence": 61
      },
      "sourceRefs": [
        {
          "sourceId": "nist-codata",
          "title": "2022 CODATA Fundamental Physical Constants",
          "trust": "primary",
          "sourceType": "physical-constants",
          "recordHash": "fnv1a32-333cff52",
          "url": "https://physics.nist.gov/cuu/Constants/Table/allascii.txt"
        },
        {
          "sourceId": "nist-chemistry-webbook",
          "title": "NIST Chemistry WebBook SRD 69",
          "trust": "primary",
          "sourceType": "chemistry-reference-database",
          "recordHash": "fnv1a32-d9ac987b",
          "url": "https://webbook.nist.gov/chemistry/"
        },
        {
          "sourceId": "materials-project",
          "title": "Materials Project API",
          "trust": "primary",
          "sourceType": "materials-property-api",
          "recordHash": "fnv1a32-c46b2daa",
          "url": "https://docs.materialsproject.org/downloading-data/using-the-api"
        },
        {
          "sourceId": "cantera",
          "title": "Cantera",
          "trust": "open-source",
          "sourceType": "chemistry-transport-toolkit",
          "recordHash": "fnv1a32-883bdb34",
          "url": "https://cantera.org/"
        },
        {
          "sourceId": "moose-framework",
          "title": "MOOSE Framework",
          "trust": "primary",
          "sourceType": "multiphysics-framework",
          "recordHash": "fnv1a32-a9482599",
          "url": "https://mooseframework.inl.gov/"
        },
        {
          "sourceId": "openfoam",
          "title": "OpenFOAM",
          "trust": "open-source",
          "sourceType": "cfd-toolkit",
          "recordHash": "fnv1a32-124056ab",
          "url": "https://www.openfoam.com/"
        },
        {
          "sourceId": "pds",
          "title": "Planetary Data System",
          "trust": "primary",
          "sourceType": "mission-data-archive",
          "recordHash": "fnv1a32-7c477cc2",
          "url": "https://pds.nasa.gov/datasearch/data-search/"
        }
      ],
      "artifactRefs": [
        {
          "artifactId": "artifact-materials-process-v1",
          "name": "Materials/process physics module contract",
          "claimState": "hypothesis",
          "runtimeStatus": "design-contract",
          "artifactHash": "fnv1a32-3b863280"
        }
      ],
      "contractRefs": [],
      "claimRefs": [
        {
          "claimId": "claim-spf-separation",
          "status": "Likely",
          "evidenceGrade": "C-partial",
          "promotionAllowed": false
        }
      ],
      "proofGates": [
        "Material properties are source-backed by species/material identifiers.",
        "Cantera/MOOSE/OpenFOAM artifacts are hashed with input deck/case files.",
        "Process scores remain heuristics until physics artifacts exist."
      ],
      "processEvidence": {
        "ledgerHash": "sha256-860c27709b9c2e64ffb883271d74cf5b6e44d14c8c8d2c22404f2adda2914f80",
        "processCount": 3,
        "blockedProcessCount": 3,
        "promotionAllowed": false,
        "topProcessGaps": [
          {
            "processId": "spf-db",
            "processName": "Superplastic Forming / Diffusion Bonding",
            "evidenceScore": 58,
            "bestScenarioId": "hybrid",
            "blockerCount": 3,
            "nextAction": "thermal cycle energy balance"
          },
          {
            "processId": "vacuum-sheet",
            "processName": "Vacuum Anisotropic Sheet Manufacturing",
            "evidenceScore": 61,
            "bestScenarioId": "hybrid",
            "blockerCount": 3,
            "nextAction": "MOOSE thermo-mechanical forming residual record"
          },
          {
            "processId": "oxygen-isru",
            "processName": "Oxygen Extraction / ISRU",
            "evidenceScore": 64,
            "bestScenarioId": "hybrid",
            "blockerCount": 3,
            "nextAction": "Cantera chemistry/thermodynamics run"
          }
        ]
      },
      "blockers": [
        "Claim not promotable: claim-spf-separation",
        "Materials/process gap: Superplastic Forming / Diffusion Bonding requires thermal cycle energy balance",
        "Materials/process gap: Vacuum Anisotropic Sheet Manufacturing requires MOOSE thermo-mechanical forming residual record",
        "Materials/process gap: Oxygen Extraction / ISRU requires Cantera chemistry/thermodynamics run"
      ],
      "nextActions": [
        "Claim not promotable: claim-spf-separation",
        "Materials/process gap: Superplastic Forming / Diffusion Bonding requires thermal cycle energy balance",
        "Materials/process gap: Vacuum Anisotropic Sheet Manufacturing requires MOOSE thermo-mechanical forming residual record",
        "Materials/process gap: Oxygen Extraction / ISRU requires Cantera chemistry/thermodynamics run"
      ],
      "capabilityHash": "sha256-f1a64fb4d0463e51949fafc8a590e82b46f0e20557e89a57cebdb5e6ed8df386"
    },
    {
      "id": "comms-autonomy",
      "label": "Comms, autonomy, and disruption planning",
      "businessUse": "Quantify contact gaps, store-and-forward assumptions, latency, and autonomy burden.",
      "maturityScore": 62.08,
      "maturityBand": "research-backed",
      "commercializationAllowed": false,
      "scores": {
        "sourceCoverage": 100,
        "artifactCoverage": 55.6,
        "claimCoverage": 90.96,
        "sidecarCoverage": 10,
        "processEvidence": null
      },
      "sourceRefs": [
        {
          "sourceId": "nasa-dtn",
          "title": "Delay/Disruption Tolerant Networking",
          "trust": "primary",
          "sourceType": "communications-program-reference",
          "recordHash": "fnv1a32-61e03fe6",
          "url": "https://www.nasa.gov/communicating-with-missions/delay-disruption-tolerant-networking/"
        },
        {
          "sourceId": "ccsds",
          "title": "Consultative Committee for Space Data Systems",
          "trust": "primary",
          "sourceType": "space-data-standard",
          "recordHash": "fnv1a32-75fdfe19",
          "url": "https://ccsds.org/"
        },
        {
          "sourceId": "spice-gf",
          "title": "SPICE Geometry Finder",
          "trust": "primary",
          "sourceType": "ephemeris-event-software",
          "recordHash": "fnv1a32-97d74c96",
          "url": "https://naif.jpl.nasa.gov/pub/naif/toolkit_docs/C/req/gf.html"
        },
        {
          "sourceId": "horizons-api",
          "title": "JPL Horizons API",
          "trust": "primary",
          "sourceType": "ephemeris-api",
          "recordHash": "fnv1a32-9335c241",
          "url": "https://ssd-api.jpl.nasa.gov/doc/horizons.html"
        }
      ],
      "artifactRefs": [
        {
          "artifactId": "artifact-spice-gf-windows-v1",
          "name": "SPICE Geometry Finder event-window contract",
          "claimState": "adapter-contract",
          "runtimeStatus": "adapter-fixture",
          "artifactHash": "fnv1a32-6f7f670c"
        }
      ],
      "contractRefs": [
        {
          "contractId": "spice-gf-event-window-v1",
          "tool": "NASA NAIF SPICE Geometry Finder",
          "domain": "ephemeris-event-windows",
          "validationStatus": "blocked-no-runtime-artifact",
          "promotionAllowed": false
        }
      ],
      "claimRefs": [
        {
          "claimId": "claim-dtn",
          "status": "Verified",
          "evidenceGrade": "A-reviewable",
          "promotionAllowed": true
        }
      ],
      "proofGates": [
        "Contact windows are generated from ephemeris/event tools.",
        "DTN assumptions are explicitly marked as architecture assumptions.",
        "Blackout-safe manufacturing windows include process duration plus margin."
      ],
      "processEvidence": null,
      "blockers": [
        "Runtime sidecar validation blocked: spice-gf-event-window-v1"
      ],
      "nextActions": [
        "Runtime sidecar validation blocked: spice-gf-event-window-v1"
      ],
      "capabilityHash": "sha256-8f13afb390aa9535da156eb354c9272eaec138d89c282d8e4dea2f91de40f749"
    },
    {
      "id": "economics-optimization",
      "label": "Economics, optimization, and portfolio frontiers",
      "businessUse": "Show which assumptions move rankings and where a scenario stops winning.",
      "maturityScore": 54.03,
      "maturityBand": "contracted-backlog",
      "commercializationAllowed": false,
      "scores": {
        "sourceCoverage": 85,
        "artifactCoverage": 55.3,
        "claimCoverage": 70,
        "sidecarCoverage": 10,
        "processEvidence": null
      },
      "sourceRefs": [
        {
          "sourceId": "openmdao",
          "title": "OpenMDAO",
          "trust": "primary",
          "sourceType": "optimization-framework",
          "recordHash": "fnv1a32-9ef7d3cb",
          "url": "https://openmdao.org/"
        },
        {
          "sourceId": "dymos",
          "title": "Dymos",
          "trust": "open-source",
          "sourceType": "optimal-control-library",
          "recordHash": "fnv1a32-31dbd31c",
          "url": "https://openmdao.github.io/dymos/"
        }
      ],
      "artifactRefs": [
        {
          "artifactId": "artifact-economics-uncertainty-v1",
          "name": "Economics and Monte Carlo frontier artifact",
          "claimState": "model-derived-unvalidated",
          "runtimeStatus": "deterministic-generated-monte-carlo",
          "artifactHash": "fnv1a32-83d7b008"
        }
      ],
      "contractRefs": [
        {
          "contractId": "openmdao-dymos-optimization-v1",
          "tool": "OpenMDAO/Dymos",
          "domain": "optimization-and-sensitivity",
          "validationStatus": "blocked-no-runtime-artifact",
          "promotionAllowed": false
        }
      ],
      "claimRefs": [],
      "proofGates": [
        "Dated launch/capex/opex source ranges are attached before promotion.",
        "Monte Carlo seeds and frontier outputs are reproducible.",
        "Optimization objectives and constraints are visible to reviewers."
      ],
      "processEvidence": null,
      "blockers": [
        "Runtime sidecar validation blocked: openmdao-dymos-optimization-v1",
        "Dated launch/capex/opex/market source records are not attached."
      ],
      "nextActions": [
        "Runtime sidecar validation blocked: openmdao-dymos-optimization-v1",
        "Dated launch/capex/opex/market source records are not attached."
      ],
      "capabilityHash": "sha256-bc5c0a71ef42ed8b2e8d50ce4d022e846c30a23941169b3059103422a81615ae"
    },
    {
      "id": "small-body-feedstock",
      "label": "Small-body feedstock screening",
      "businessUse": "Screen asteroids without pretending close approach geometry proves resource composition.",
      "maturityScore": 50.09,
      "maturityBand": "contracted-backlog",
      "commercializationAllowed": false,
      "scores": {
        "sourceCoverage": 100,
        "artifactCoverage": 56.15,
        "claimCoverage": 23.5,
        "sidecarCoverage": 10,
        "processEvidence": null
      },
      "sourceRefs": [
        {
          "sourceId": "sbdb-api",
          "title": "JPL Small-Body Database API",
          "trust": "primary",
          "sourceType": "small-body-orbit-api",
          "recordHash": "fnv1a32-93c0fe91",
          "url": "https://ssd-api.jpl.nasa.gov/doc/sbdb.html"
        },
        {
          "sourceId": "cad-api",
          "title": "SBDB Close Approach Data API",
          "trust": "primary",
          "sourceType": "close-approach-api",
          "recordHash": "fnv1a32-ba0c45bb",
          "url": "https://ssd-api.jpl.nasa.gov/doc/cad.html"
        },
        {
          "sourceId": "mpc",
          "title": "Minor Planet Center Data",
          "trust": "primary",
          "sourceType": "small-body-observation-archive",
          "recordHash": "fnv1a32-62694497",
          "url": "https://minorplanetcenter.net/data"
        },
        {
          "sourceId": "pds",
          "title": "Planetary Data System",
          "trust": "primary",
          "sourceType": "mission-data-archive",
          "recordHash": "fnv1a32-7c477cc2",
          "url": "https://pds.nasa.gov/datasearch/data-search/"
        },
        {
          "sourceId": "esa-psa",
          "title": "ESA Planetary Science Archive",
          "trust": "primary",
          "sourceType": "planetary-mission-archive",
          "recordHash": "fnv1a32-5c0abe4d",
          "url": "https://archives.esac.esa.int/psa/"
        },
        {
          "sourceId": "jaxa-darts",
          "title": "DARTS Space Science Data Archive",
          "trust": "primary",
          "sourceType": "space-science-archive",
          "recordHash": "fnv1a32-e07b656d",
          "url": "https://darts.isas.jaxa.jp/"
        }
      ],
      "artifactRefs": [
        {
          "artifactId": "artifact-sbdb-cad-screen-v1",
          "name": "SBDB/CAD small-body candidate screen",
          "claimState": "source-backed-blocked",
          "runtimeStatus": "deterministic-snapshot",
          "artifactHash": "fnv1a32-38332261"
        },
        {
          "artifactId": "artifact-trajectory-sidecar-v1",
          "name": "Orekit/GMAT/Tudat trajectory validation sidecar",
          "claimState": "blocked",
          "runtimeStatus": "contract-ready-no-runtime-artifact",
          "artifactHash": "fnv1a32-0fa3828b"
        }
      ],
      "contractRefs": [
        {
          "contractId": "orekit-propagation-v1",
          "tool": "Orekit",
          "domain": "trajectory-propagation",
          "validationStatus": "blocked-no-runtime-artifact",
          "promotionAllowed": false
        },
        {
          "contractId": "tudat-transfer-v1",
          "tool": "Tudat",
          "domain": "cross-tool-trajectory-validation",
          "validationStatus": "blocked-no-runtime-artifact",
          "promotionAllowed": false
        }
      ],
      "claimRefs": [
        {
          "claimId": "claim-helium3",
          "status": "Hypothesis",
          "evidenceGrade": "D-blocked",
          "promotionAllowed": false
        }
      ],
      "proofGates": [
        "SBDB/CAD candidate records are object-specific.",
        "MPC observation context is linked where material decisions depend on orbit confidence.",
        "Taxonomy, spectra, or mission data is attached before resource promotion."
      ],
      "processEvidence": null,
      "blockers": [
        "Runtime sidecar validation blocked: orekit-propagation-v1",
        "Runtime sidecar validation blocked: tudat-transfer-v1",
        "Claim not promotable: claim-helium3"
      ],
      "nextActions": [
        "Runtime sidecar validation blocked: orekit-propagation-v1",
        "Runtime sidecar validation blocked: tudat-transfer-v1",
        "Claim not promotable: claim-helium3"
      ],
      "capabilityHash": "sha256-1b30bc23134ff16878cdbaec11e9503937d16fafa7bb3669739e99caf25a219a"
    },
    {
      "id": "trajectory-logistics",
      "label": "Trajectory and logistics validation",
      "businessUse": "Estimate transfer feasibility, mass burden, and scenario logistics with independent tool evidence.",
      "maturityScore": 49.98,
      "maturityBand": "contracted-backlog",
      "commercializationAllowed": false,
      "scores": {
        "sourceCoverage": 82,
        "artifactCoverage": 43.4,
        "claimCoverage": 70,
        "sidecarCoverage": 10,
        "processEvidence": null
      },
      "sourceRefs": [
        {
          "sourceId": "orekit",
          "title": "Orekit",
          "trust": "open-source",
          "sourceType": "astrodynamics-library",
          "recordHash": "fnv1a32-88a8d672",
          "url": "https://www.orekit.org/"
        },
        {
          "sourceId": "gmat",
          "title": "General Mission Analysis Tool",
          "trust": "primary",
          "sourceType": "mission-analysis-tool",
          "recordHash": "fnv1a32-3743e565",
          "url": "https://software.nasa.gov/software/GSC-17177-1"
        },
        {
          "sourceId": "tudat",
          "title": "Tudat Space / TudatPy",
          "trust": "open-source",
          "sourceType": "astrodynamics-toolkit",
          "recordHash": "fnv1a32-c238f1d2",
          "url": "https://docs.tudat.space/en/latest/"
        },
        {
          "sourceId": "openmdao",
          "title": "OpenMDAO",
          "trust": "primary",
          "sourceType": "optimization-framework",
          "recordHash": "fnv1a32-9ef7d3cb",
          "url": "https://openmdao.org/"
        },
        {
          "sourceId": "dymos",
          "title": "Dymos",
          "trust": "open-source",
          "sourceType": "optimal-control-library",
          "recordHash": "fnv1a32-31dbd31c",
          "url": "https://openmdao.github.io/dymos/"
        }
      ],
      "artifactRefs": [
        {
          "artifactId": "artifact-trajectory-sidecar-v1",
          "name": "Orekit/GMAT/Tudat trajectory validation sidecar",
          "claimState": "blocked",
          "runtimeStatus": "contract-ready-no-runtime-artifact",
          "artifactHash": "fnv1a32-0fa3828b"
        }
      ],
      "contractRefs": [
        {
          "contractId": "orekit-propagation-v1",
          "tool": "Orekit",
          "domain": "trajectory-propagation",
          "validationStatus": "blocked-no-runtime-artifact",
          "promotionAllowed": false
        },
        {
          "contractId": "gmat-transfer-v1",
          "tool": "NASA GMAT",
          "domain": "mission-design-transfer",
          "validationStatus": "blocked-no-runtime-artifact",
          "promotionAllowed": false
        },
        {
          "contractId": "tudat-transfer-v1",
          "tool": "Tudat",
          "domain": "cross-tool-trajectory-validation",
          "validationStatus": "blocked-no-runtime-artifact",
          "promotionAllowed": false
        },
        {
          "contractId": "openmdao-dymos-optimization-v1",
          "tool": "OpenMDAO/Dymos",
          "domain": "optimization-and-sensitivity",
          "validationStatus": "blocked-no-runtime-artifact",
          "promotionAllowed": false
        }
      ],
      "claimRefs": [],
      "proofGates": [
        "At least two trajectory tools produce residual-bounded outputs.",
        "Force models, frames, time scale, and optimizer settings are recorded.",
        "Launch mass and transfer assumptions are sensitivity-tested."
      ],
      "processEvidence": null,
      "blockers": [
        "Runtime sidecar validation blocked: orekit-propagation-v1",
        "Runtime sidecar validation blocked: gmat-transfer-v1",
        "Runtime sidecar validation blocked: tudat-transfer-v1",
        "Runtime sidecar validation blocked: openmdao-dymos-optimization-v1"
      ],
      "nextActions": [
        "Runtime sidecar validation blocked: orekit-propagation-v1",
        "Runtime sidecar validation blocked: gmat-transfer-v1",
        "Runtime sidecar validation blocked: tudat-transfer-v1",
        "Runtime sidecar validation blocked: openmdao-dymos-optimization-v1"
      ],
      "capabilityHash": "sha256-bd1b2ee7d2b24ded850c560ccade38948c32d67395cb8e242c6e932dbcf19845"
    }
  ],
  "ledgerHash": "sha256-f1dc7ec56ccebef2ce81f203d8973948478d7129005c65ef75c9cca15366defd"
}
;
